import { Injectable } from '@angular/core';

import { LocalStorageService } from './local-storage.service';
import { CookieService } from './cookie.service';

@Injectable()
export class TokenStorageService {

    private _isCookieStorage: boolean = true;

    constructor(
        private _localStorageService: LocalStorageService,
        private _cookieService: CookieService,
    ) {}

    /**
     * 
     * @returns 
     */
    getAccessToken(): string | null {

        if (this._isCookieStorage) {
            const accessTokenFromCookie = this._cookieService.get(CookieService.APP_AUTH_ACCESS_TOKEN_KEY);
            return accessTokenFromCookie ? accessTokenFromCookie as string : null;
        } else {
            return this._localStorageService.getItem(LocalStorageService.APP_AUTH_ACCESS_TOKEN_KEY) as string;
        }
    }

    /**
     * 
     * @param token 
     */
    saveAccessToken(token: string) {

        if (this._isCookieStorage) {
            // set access token to be expired
            this._cookieService.delete(CookieService.APP_AUTH_ACCESS_TOKEN_KEY);
            // set new access token
            this._cookieService.set(CookieService.APP_AUTH_ACCESS_TOKEN_KEY, token);
        } else {
            // remove access token to be expired
            this._localStorageService.removeItem(LocalStorageService.APP_AUTH_ACCESS_TOKEN_KEY);
            // set new access token
            this._localStorageService.setItem(LocalStorageService.APP_AUTH_ACCESS_TOKEN_KEY, token);
        }
    }

    /**
     * 
     * @returns 
     */
    getRefreshToken(): string | null {

        if (this._isCookieStorage) {
            const refeshTokenFromCookie = this._cookieService.get(CookieService.APP_AUTH_REFRESH_TOKEN_KEY);
            return refeshTokenFromCookie ? refeshTokenFromCookie as string : null;
        } else {
            return this._localStorageService.getItem(LocalStorageService.APP_AUTH_REFRESH_TOKEN_KEY) as string;
        }
    }

    /**
     * 
     * @returns 
     */
    getRefreshTokenExpiry(): number | null {

        if (this._isCookieStorage) {
            const refeshTokenExpiryFromCookie = this._cookieService.get(CookieService.APP_AUTH_REFRESH_TOKEN_EXPIRY_KEY);
            return refeshTokenExpiryFromCookie ? refeshTokenExpiryFromCookie as number : null;
        } else {
            return this._localStorageService.getItem(LocalStorageService.APP_AUTH_REFRESH_TOKEN_EXPIRY_KEY) as number | null;
        }
    }

    /**
     * 
     * @param token 
     */
    saveRefreshToken(token: string, expiry: number) {

        if (this._isCookieStorage) {
            // set access token to be expired
            this._cookieService.delete(CookieService.APP_AUTH_REFRESH_TOKEN_KEY);
            // set new access token
            this._cookieService.set(CookieService.APP_AUTH_REFRESH_TOKEN_KEY, token, expiry);
        } else {
            // remove access token to be expired
            this._localStorageService.removeItem(LocalStorageService.APP_AUTH_REFRESH_TOKEN_KEY);
            // set new access token
            this._localStorageService.setItem(LocalStorageService.APP_AUTH_REFRESH_TOKEN_KEY, token);
            this._localStorageService.setItem(LocalStorageService.APP_AUTH_REFRESH_TOKEN_EXPIRY_KEY, expiry);
        }
    }


    /**
     * 
     */
    removeTokens() {
        
        if (this._isCookieStorage) {
            // set access token to be expired
            this._cookieService.delete(CookieService.APP_AUTH_ACCESS_TOKEN_KEY);
            // set refresh token to expired
            this._cookieService.delete(CookieService.APP_AUTH_REFRESH_TOKEN_KEY);
        } else {
            this._localStorageService.removeItem(LocalStorageService.APP_AUTH_ACCESS_TOKEN_KEY);
            this._localStorageService.removeItem(LocalStorageService.APP_AUTH_REFRESH_TOKEN_KEY);
            this._localStorageService.removeItem(LocalStorageService.APP_AUTH_REFRESH_TOKEN_EXPIRY_KEY);
        }

        // Delete local storage for authorized organization of current authenticated user
        // TODO - refactoring potential?
        this._localStorageService.removeItem(LocalStorageService.APP_AUTH_ORGS_KEY);
    }
}
